import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import { DIFFERENTIATORS } from "../content/landingContent.js";
import FeatureGrid from "./FeatureGrid.js";
import ScenePanel from "./ScenePanel.js";
import SectionHeading from "./SectionHeading.js";

const DifferenceScene = observer(() => {
  const { t } = useTranslation();
  return (
    <ScenePanel image="/assets/landing/deterministic-engine.webp" alt={t("landing.difference.artAlt")} side="left">
      <SectionHeading eyebrow={t("landing.difference.eyebrow")} title={t("landing.difference.title")}
        body={t("landing.difference.body")} />
      <FeatureGrid items={DIFFERENTIATORS} />
    </ScenePanel>
  );
});

export default DifferenceScene;
